export default __webpack_public_path__ + "static/media/img-license.3822ab5d.svg";